import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
    publicLoading: false,
    privateLoading: false,
    publicTermsAndConditions: {
        title: 'Terms & Conditions',
        description: ''
    },
    publicPrivacyPolicy: {
        title: 'Privacy Policy',
        description: ''
    },
};

export const resourcesSlice = createSlice({
    name: 'resources',
    initialState,
    reducers: {
        loadPublicTnC: (state, action) => {
            state.publicLoading = true
        },
        publicTncLoaded: (state, action) => {
            state.publicLoading = false
            state.publicTermsAndConditions = action.payload
        },
        loadPublicPp: (state, action) => {
            state.publicLoading = true
        },
        publicPpLoaded: (state, action) => {
            state.publicLoading = false
            state.publicPrivacyPolicy = action.payload
        },
        failedToLoadResource: (state, action) => {
            state.publicLoading = false
        },
        updateTnc: (state, action) => {
            state.loading = true
        },
        tncUpdated: (state, action) => {
            state.loading = false
        },
        updatePp: (state, action) => {
            state.loading = true
        },
        ppUpdated: (state, action) => {
            state.loading = false
        },
    }
});

export const {
    loadPublicTnC,
    loadPublicPp,
    publicTncLoaded,
    publicPpLoaded,
    failedToLoadResource,
    updateTnc,
    tncUpdated,
    updatePp,
    ppUpdated,
} = resourcesSlice.actions

export default resourcesSlice.reducer;
